'use client'

import Create from './Create'

// Preference comes from the pc_generate_ui cookie read server-side in page.jsx.
export default function CreateVariantRouter({ initialLegacy = false }) {
  return <Create uiVariant={initialLegacy ? 'A' : 'B'} />
}
